import React, {Component} from "react";
import PropTypes from 'prop-types';
import VideoItem from "./VideoItem";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../../actions/gallery";
import * as galleryReducers from "../../../reducers/gallery";
import ReactImageFallback from "react-image-fallback";
import $ from "jquery";
import { API_PATH} from "../../../constants";


class Slider extends Component {

    constructor(props) {
        super(props);
        this.state = {

            withInfo : true,
            showInfo : false,
            downLoad : true,
            currentItem: {}

        };
        this.resetActiveItem = this. resetActiveItem.bind(this);

    }

     componentDidMount() {

         console.log(this.props.galleryInfo);

     }


    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $('#carouselExampleIndicators').bind('slide.bs.carousel', function (e) {
            alert('slide event!');
        });

        /*if(this.props.galleryInfo.fileContent !== prevProps.galleryInfo.fileContent) {
            var a = document.createElement('a');
            var url = window.URL.createObjectURL(this.props.galleryInfo.fileContent);
            a.href = url;
            a.download = 'myfile.jpg';
            a.click();
            window.URL.revokeObjectURL(url);
        }*/
    }

    updateItemIndex(e, type) {

        var indexStatus = 0;
        if(type === 'prev') {
            if(this.props.galleryInfo.itemIndex >0) {
                --this.props.galleryInfo.itemIndex;
            } else {
                this.props.galleryInfo.itemIndex = this.props.galleryData.galleryItems.length-1;
            }

        }
        else{
            if(this.props.galleryInfo.itemIndex < this.props.galleryData.galleryItems.length-1) {
                ++this.props.galleryInfo.itemIndex;
            }
            else {
                this.props.galleryInfo.itemIndex = 0;
            }
        }
        let itemIndex = this.props.galleryInfo.itemIndex;
        let currentItem = this.props.galleryData.galleryItems[itemIndex];
        this.setState({currentItem: currentItem });

        console.log(this.props.galleryInfo.itemIndex);
        $(".sl-item").removeClass('active');
        $(".sl-item:eq("+this.props.galleryInfo.itemIndex+")").addClass('active');


        let data = {"index" :  this.props.galleryInfo.itemIndex};
        this.props.setItemId(data);
    }

    showItemInfo() {

        this.setState({showInfo: true });
        console.log(this.props.galleryInfo);
        let itemIndex = this.props.galleryInfo.itemIndex;
        let currentItem = this.props.galleryData.galleryItems[itemIndex];

        /*let carousel = document.getElementsByClassName("carousel-item");
        let img = carousel[itemIndex].querySelector("img");

        img.src = currentItem.img_path;


        var width = img.naturalWidth;
        var height = img.naturalHeight;


        currentItem.img_dim = width+" X "+height;*/
        this.setState({currentItem: currentItem });

        console.log( this.props.galItems);
        console.log(this.props.galleryInfo);
    }

    closeItemInfo() {

        this.setState({showInfo: false });
    }


    downloadItem(e) {

        e.preventDefault();

        let itemIndex = this.props.galleryInfo.itemIndex;
        let currentItem = this.props.galleryData.galleryItems[itemIndex];
        let completeFilePath = currentItem.img_path;
        this.props.download({filename : currentItem.img_path});
    }
    resetActiveItem() {

        var graphicBlocks = document.getElementsByClassName('ind-galler-list');
        let itemIndex = this.props.galleryInfo.itemIndex;

        if( this.props.galleryInfo.gal_type === 'VIDEO') {
            var videoCtr = document.getElementById("video"+itemIndex);
            var currentVideo = videoCtr.getElementsByTagName('video')[0];
            currentVideo.pause();
        }
        graphicBlocks[itemIndex+1].classList.remove("active");



    }


    render() {

        let items = this.props.galItems;

        let currentItem = this.state.currentItem;

        return (
            <div className="modal fade gallery-modal" id="galleryModal">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close md-close" data-dismiss="modal" onClick={() => this.resetActiveItem()}></button>
                        </div>
                        <div className="modal-body">

                            <div className="gallery-modal-wrapper">
                                <div id="carouselExampleIndicators" className="carousel slide gallery-modal" data-ride="carousel" >
                                    <div className="carousel-inner">
                                        {items && this.props.galleryInfo.gal_type === 'MY_UPLOADS' &&
                                            items.map((entry, index) => {
                                                let imgpath = entry.img_path;
                                                let defImgSrc = require("../../../assets/images/no-image.jpg");

                                                return(
                                                    <div className="carousel-item item">
                                                        <ReactImageFallback
                                                            className="d-block w-100 "
                                                            src={imgpath}
                                                            fallbackImage={defImgSrc}
                                                            initialImage={defImgSrc}
                                                            alt="cool image should be here"
                                                        />
                                                    </div>
                                                )
                                            })

                                        }
                                        

                                        {items && this.props.galleryInfo.gal_type === 'VIDEO' &&
                                        items.map((entry, index) =>
                                            <VideoItem item = {entry} iteration={index} />
                                        )
                                        }
                                    </div>
                                    <a className="carousel-control-prev" href="#carouselExampleIndicators"
                                       role="button" data-slide="prev"  onClick={(e) => this.updateItemIndex(e,'prev')}>
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Previous</span>
                                    </a>
                                    <a className="carousel-control-next" href="#carouselExampleIndicators"
                                       role="button" data-slide="next" onClick={(e) => this.updateItemIndex(e,'next')}>
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Next</span>
                                    </a>
                                </div>
                                {this.state.withInfo &&
                                <div className="gallery-option">
                                    <button className="file-info-gallery" onClick = {(e) => this.showItemInfo(e)}></button>
                                </div>

                                }
                                {this.state.withInfo &&
                                <div className={this.state.showInfo? 'info-toggler-block  active-in' : 'info-toggler-block '}>

                                    <table className="table toggle-table">
                                        <tbody>
                                        <tr>
                                            <td>Image Size</td>
                                            <td align="right" className="inactive">{parseFloat(currentItem.img_size).toFixed(2)} MB</td>
                                        </tr>
                                        <tr>
                                            <td>Dimensions</td>
                                            <td align="right" className="inactive">{currentItem.img_dim}</td>
                                        </tr>
                                        <tr>
                                            <td>Type</td>
                                            <td align="right" className="inactive">{currentItem.img_type}</td>
                                        </tr>
                                        <tr>
                                            <td>Uploaded By</td>
                                            <td align="right" className="inactive">{currentItem.uploaded_by}</td>
                                        </tr>
                                        <tr>
                                            <td>Uploaded On</td>
                                            <td align="right" className="inactive">{currentItem.uploaded_on}</td>
                                        </tr>
                                        <tr>
                                            <td>Downloads count</td>
                                            <td align="right" className="inactive">{currentItem.downloads}</td>
                                        </tr>
                                        </tbody>
                                    </table>

                                    <div className="togller-inside-opt">

                                        {this.state.downLoad && this.props.galleryInfo.gal_type === 'MY_UPLOADS' &&
                                        <a href={API_PATH + "downloadImage.php?filename=" + this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].img_path}
                                           download> Download</a>
                                        }
                                        {this.state.downLoad && this.props.galleryInfo.gal_type === 'VIDEO' &&
                                        <a href=""
                                           download> Download</a>
                                        }

                                        <button className="toggle-close" onClick = {(e) => this.closeItemInfo(e)}></button>
                                    </div>

                                </div>
                                }
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }

}

Slider.propTypes = {
    gal_type: PropTypes.string
}

function mapStateToProps(state) {

    return {
        galleryInfo  :galleryReducers.setGalleryUpdate(state),
        galleryData  :galleryReducers.getGalleryData(state)
    };

}


export default  withRouter(connect(mapStateToProps, {
    setItemId : galleryActions.setItemId,
    download : galleryActions.downloadFile
})(Slider));


// WEBPACK FOOTER //
// ./src/components/includes/Slider/index.js